import React from 'react';
import { getStatusTone, TONE_CLASS, TONE_MARK } from './orderStatus';

/**
 * The single status pill for every order screen.
 *
 * Previously duplicated in OrderView and OrderPreviewDrawer with different
 * radii and padding; both copies are now this component.
 */
const OrderStatusPill = ({ statusId, label, size = 'md', showDot = true }) => {
  const tone = getStatusTone(statusId);
  const sizing =
    size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-medium rounded-full border whitespace-nowrap ${sizing} ${TONE_CLASS[tone]}`}
    >
      {showDot && (
        <span
          className="w-1.5 h-1.5 rounded-full shrink-0"
          style={{ backgroundColor: TONE_MARK[tone] }}
          aria-hidden="true"
        />
      )}
      {label || 'Unknown'}
    </span>
  );
};

export default OrderStatusPill;
